import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { http, HttpResponse } from 'msw'

export const deleteFamilyMemberPrivacyDocument = http.delete<object, object, undefined>(
  apiBaseUrl + '/familyMembers/:familyMemberId/documents/:documentId',
  () => {
    return HttpResponse.json(undefined, { status: 204 })
  },
)
